export const getUrlWithApi = (url: string): string => process.env.REACT_APP_API_URL.concat(url);
